import React from 'react';

import Modal from 'react-bootstrap/Modal';

import ClientSideTrimVideo from '../../components/ClientSideTrimVideo';

import closeIcon from '../../../../assets/images/closeIcon.svg';
import classes from '../../../../modals/EditSectionModal/styles.module.scss';

/**
 * Client-side EditSectionModal for trimming videos
 * Works with local assets and updates Redux state directly
 */
export default function ClientSideEditSectionModal({
  show,
  handleClose,
  title,
  asset,
  itemId,
  itemDuration,
  existingTrimStart,
  existingTrimEnd,
  onSave,
}) {
  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.EditSectionModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
      autoFocus={false}
      enforceFocus={false}
    >
      <div onClick={(event) => event.stopPropagation()}>
        <i className={classes.closeIcon} onClick={handleClose}>
          <img src={closeIcon} alt="Close" />
        </i>
        <div className={classes.content}>
          <h2 className={classes.title}>{title}</h2>
          <ClientSideTrimVideo
            asset={asset}
            itemId={itemId}
            itemDuration={itemDuration}
            existingTrimStart={existingTrimStart}
            existingTrimEnd={existingTrimEnd}
            onSave={(trimData) => {
              if (onSave) {
                onSave(trimData);
              }
              handleClose();
            }}
          />
        </div>
      </div>
    </Modal>
  );
}

